import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";

import AdminAjoutFournisseur from "./AdminAjoutFournisseur";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function ListeFournisseursMontures() {
  const [fournisseurs, setFournisseurs] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getFournisseurs() {
      axios
        .get(`${API_URL}/api/fournisseurs`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseurs(data);
        });
    }

    getFournisseurs();
  }, []);

  let lettrePrecedente = "";

  return (
    <div className="listeMain">
      <h1>Gestion des fournisseurs</h1>
      <MDBBtn type="button" outline color="primary" onClick={handleShow}>
        Ajouter un fournisseur
      </MDBBtn>
      <ul>
        {fournisseurs ? (
          fournisseurs.map((fournisseur) => {
            if (fournisseur.nom.charAt(0).toUpperCase() !== lettrePrecedente) {
              lettrePrecedente = fournisseur.nom.charAt(0).toUpperCase();
              return (
                <div>
                  <div className="initial">{lettrePrecedente}</div>
                  <ul className="firstAfterInitial">
                    <li key={fournisseur.id}>
                      <Link
                        to={`/admin-fournisseurs-montures/${fournisseur.id}`}
                      >
                        {fournisseur.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            } else {
              return (
                <div>
                  <ul>
                    <li key={fournisseur.id}>
                      <Link
                        to={`/admin-fournisseurs-montures/${fournisseur.id}`}
                      >
                        {fournisseur.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            }
          })
        ) : (
          <li>Loading</li>
        )}
      </ul>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer un fournisseur </MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutFournisseur category="fournisseurs" />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default ListeFournisseursMontures;
